import React from 'react';
import { REASONS_TOP, REASONS_LIST } from '../mock';
import Reveal from './Reveal';

export default function WhyUs() {
  return (
    <section id="perche-noi" className="relative py-24 md:py-32 bg-[#1a1a1a] text-white overflow-hidden">
      <div className="absolute inset-0 opacity-30 pointer-events-none">
        <div className="absolute -top-32 -right-20 w-[500px] h-[500px] rounded-full bg-[#1e6cb0]/20 blur-3xl drift" />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 md:px-8">
        <Reveal variant="fade">
          <div className="flex items-start gap-3 mb-10">
            <span className="text-[#5eb0e8] font-bold text-[14px] tracking-[0.18em]">06</span>
            <span className="w-10 h-px mt-3 bg-[#5eb0e8]/60" />
            <span className="text-[12px] tracking-[0.2em] uppercase font-semibold text-white/60">
              Perché noi
            </span>
          </div>
        </Reveal>

        <div className="grid lg:grid-cols-12 gap-10 mb-16">
          <Reveal as="h2" variant="up" delay={80} className="lg:col-span-8 heading-mega text-[42px] sm:text-[56px] md:text-[80px] text-white">
            Non siamo<br />per tutti.<br />
            <span className="text-[#5eb0e8]">Per te,</span> forse.
          </Reveal>
          <Reveal as="p" variant="up" delay={220} className="lg:col-span-4 text-[16px] leading-relaxed text-white/70 lg:mt-6">
            Lavoriamo con chi vuole crescere davvero, non con chi cerca il preventivo più basso.
            Se ci riconosci in questi quattro punti, probabilmente siamo quelli giusti.
          </Reveal>
        </div>

        {/* Top three pills */}
        <div className="grid md:grid-cols-3 gap-5 mb-16">
          {REASONS_TOP.map((r, i) => (
            <Reveal key={r.tag} variant="up" delay={i * 130} duration={760}>
              <div className="p-7 rounded-3xl bg-white/[0.04] border border-white/10 hover:border-[#5eb0e8]/40 transition-colors h-full">
                <div className="text-[#5eb0e8] font-bold text-[14px] tracking-[0.18em] mb-3">{r.tag}</div>
                <h3 className="font-display text-[22px] font-bold text-white mb-2">{r.title}</h3>
                <p className="text-[14px] leading-relaxed text-white/70">{r.body}</p>
              </div>
            </Reveal>
          ))}
        </div>

        {/* List with numbers */}
        <div className="divide-y divide-white/10 border-t border-white/10">
          {REASONS_LIST.map((r, i) => (
            <Reveal key={r.n} variant="up" delay={i * 90}>
              <div className="py-8 md:py-10 grid md:grid-cols-12 gap-6 group">
                <div className="md:col-span-3 text-[#5eb0e8] font-bold text-[14px] tracking-[0.18em]">
                  {r.n}
                </div>
                <div className="md:col-span-9">
                  <h3 className="font-display text-[24px] md:text-[32px] font-bold text-white mb-3 group-hover:text-[#7cc3f0] transition-colors">
                    {r.title}
                  </h3>
                  <p className="text-[16px] leading-relaxed text-white/70 max-w-3xl">
                    {r.body}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
